/** Components */
import './components/a-lang-switch.js';
import './components/m-shopping-dots.js';
import './components/m-teaser-carousel.js';
import './components/m-navigation.js';

/** Custom Elements */
import './custom-elements/vi-carousel.js';
import './custom-elements/vi-tooltip.js';
import './custom-elements/vi-dialog.js';
import './custom-elements/vi-form.js';
import './custom-elements/vi-planning-examples.js';

import translations from './foundation/translations.js';

const language = document.documentElement.lang;
window.translations = translations[language] ?? translations.en;
